<template>
  <div class="leo2-ok-header">
    <div class="ok-mask" v-if="isMask"><!-- 遮罩层 --></div>
    <div class="header-inner">
      <a href="/" class="ui-navbar-logo" title="游好赚官网">
        <img src="../assets/images/logo.png" />
      </a>
      <div class="menu-block">
        <!-- <router-link to="/">首页</router-link> -->
        <!-- <router-link to="/about">关于我们</router-link> -->
        <!--<router-link to="/news-detail">新闻详情</router-link>-->
        <!-- <router-link to="/news">资讯动态</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ok-header",
  data() {
    return {
      isMask: true,
    };
  },
  mounted() {
    // 监听鼠标滚动事件  // chrome and ie
    window.addEventListener(
      "mousewheel",
      () => {
        if (this.getScrollTop() > 0) {
          this.isMask = true;
        } else {
          this.isMask = true;
        }
      },
      true,
    );

    // firefox
    window.addEventListener(
      "DOMMouseScroll",
      () => {
        if (this.getScrollTop() > 0) {
          this.isMask = true;
        } else {
          this.isMask = true;
        }
      },
      true,
    );
  },
  methods: {
    // 获取浏览器的高度
    getScrollTop() {
      let scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      return scroll_top;
    },
  },
};
</script>

<style scoped lang="scss">
.leo2-ok-header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 80px;
  z-index: 99;

  .ok-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #fff;
  }

  .header-inner {
    position: relative;
    width: 1080px;
    height: 80px;
    margin: 0 auto;

    .ui-navbar-logo {
      display: inline-block;
      margin-top: 12px;
      float: left;

      img {
        width: 139px;
        height: auto;
        /*padding-left: 20px;*/
      }
    }
  }

  .menu-block {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -19px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    text-align: right;

    a {
      text-decoration: none;
      color: white;
      font-size: 16px;
      margin-left: 50px;
    }
  }
}
</style>
